import React, { useContext } from 'react';
import { ValidatorForm } from 'components/FormHelpers/FormInputs';
import { closeModal } from 'actions/common';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { CTSUCardActions } from 'components';
import { compose, withHandlers, withState } from 'recompose';
import { AppContext } from '@ctsu/loader';
import { withChangeHandlers } from 'helpers/Change';
import { FormViewContent } from 'components/FormViewContent';
import atoms from 'ctsutheme/components/atoms';
import molecules from 'ctsutheme/components/molecules';
import { createUnregisterStudy } from 'actions/protocols/admin';
import { bindLogger } from 'helpers/BindLogger';
import { httpStatusEnum } from 'appconstants';
import { openSnackbar } from 'helpers/Notifier';
import { openConfirmation } from 'helpers/Confirmation';
import { getEncodedQueryParams } from 'helpers';
import { useHistory } from 'react-router-dom';
import { getProtocolDetails } from 'actions/protocols/protocoldetail';
import {
    ActivatedOn, 
    Comments, 
    GroupProtStatus, 
    GrpProtStatusDate, 
    LeadGroup, 
    MatchBox, 
    OpenLoadToRave, 
    OpenProtocol, 
    OpenSlotReservation, 
    ProtAutoComplete, 
    ProtNumber,
    ProtTitle,
    // RaveStudy,
    RelationType,
    Step,
    cancelModal
} from './UnregisteredStudyComponents';


const { Divider, Typography } = atoms;
const { List, ListSubHeader } = molecules;

const defaultUnregisteredStudy = {   
    isMatchboxStudy: false,
    isSlotReservation: false,
    isOpenLdRave: false,
    isEnrollThruOpen: false,
    isRave: false,
    relationType: 'Standalone'
};

const CreateUnregisterStudy = ({
    resetForm,
    state,
    handleChange,
    handleSelChange,
    handleDateChange,
    saveUnregisterStudy,
    cancel,
    setState,
    onCreateUnregisterStudy
}) => {
    const context = useContext(AppContext);
    const history = useHistory();
    return (
        <ValidatorForm onSubmit={() => saveUnregisterStudy(context, onCreateUnregisterStudy, history)} className="key-value-pair-wrapper">
            <FormViewContent
                primaryText="Linked Main Protocol"
                name="linkedMainProtNum"
                secondaryText={
                (<ProtAutoComplete handleInputChange={(prot) => {
                    setState({ ...state, linkedMainProtNum: prot });
                }} />)
                }
            />
            <Divider />
            <FormViewContent
                primaryText="Protocol Number"
                name="protocolNumber"
                secondaryText={
                (<ProtNumber setState={setState} state={state} handleChange={handleChange} />)
                }
            />
            <Divider />
            <FormViewContent
                primaryText="Protocol Title"
                name="title"
                secondaryText={
                (<ProtTitle state={state} handleChange={handleChange} />)
                }
            />
            <Divider />
            <FormViewContent
                primaryText="Lead Group"
                name="leadGrp"
                secondaryText={
                (<LeadGroup handleSelChange={handleSelChange} state={state} />)
                }
            />
            <Divider />
            <FormViewContent
                primaryText="Group Protocol Status"
                name="grpProtStatus"
                secondaryText={
                (<GroupProtStatus handleSelChange={handleSelChange} state={state} />)
                }
            />
            <Divider />
            <FormViewContent
                primaryText="Group Protocol Status Date"
                name="grpProtStatusDate"
                secondaryText={
                (<GrpProtStatusDate state={state} handleDateChange={handleDateChange} />)
                }
            />
            <Divider />
            <FormViewContent
                primaryText="Activated On"
                name="activatedDate"
                secondaryText={
                (<ActivatedOn state={state} handleDateChange={handleDateChange} />)
                }
            />
            <Divider />
            <FormViewContent
                primaryText="MATCHBox Protocol?"
                name="isMatchboxStudy"
                secondaryText={
                (<MatchBox handleSelChange={handleSelChange} state={state} />)
                }
            />
            <Divider />
            <FormViewContent
                primaryText="Internal Comments"
                secondaryText={
                (<Comments state={state} handleChange={handleChange} />)
                }
                name="comments"
            />
            <Divider />
                    <List
                        subheader={(
                        <ListSubHeader flex>
                            <Typography data-id="openSetUp" inline primary>
                                OPEN Setup
                            </Typography>
                        </ListSubHeader>
                            )}
                    >
                        <FormViewContent
                            primaryText="OPEN Protocol?"
                            name="isEnrollThruOpen"
                            secondaryText={
                            (<OpenProtocol handleSelChange={handleSelChange} state={state} />)
                            }
                        />
                        <Divider />
                        <FormViewContent
                            primaryText="OPEN to Load to Rave?"
                            name="isOpenLdRave"
                            secondaryText={
                            (<OpenLoadToRave handleSelChange={handleSelChange} state={state} />)
                            }
                        />
                        <Divider />
                        <FormViewContent
                            primaryText="OPEN Slot Reservation"
                            name="isSlotReservation"
                            secondaryText={
                            (<OpenSlotReservation handleSelChange={handleSelChange} state={state} />)
                            }
                        />
                        <Divider />
                    </List>
           {state?.linkedMainProtNum && (<List
                subheader={(
                <ListSubHeader flex>
                    <Typography data-id="protRelAndEmbedStudies" inline primary>
                        Protocol Relations
                    </Typography>
                </ListSubHeader>
                    )}
            >
                <FormViewContent
                    primaryText="Step"
                    name="step"
                    secondaryText={
                    (<Step handleChange={handleChange} state={state} />)
                    }
                />
                <Divider />
                <FormViewContent
                    primaryText="Relation"
                    name="relationType"
                    secondaryText={
                    (<RelationType handleSelChange={handleSelChange} state={state} />)
                    }
                />
            </List>)}
            <Divider />
            <div
            className="color-red"
            >
            By creating this study, you are copying the Participation and Local Versions data from the Linked Main Protocol. After creation, all updates, including Participation data, Local Versions, and PSRs should be completed in the protocol pages for the new unregistered study.
            </div>
            <CTSUCardActions
                clearClick={() => resetForm()}
                cancelClick={cancel}
                clearTitle='Cancel study creation'
                hideCancel='show'
                saveText='Create Study'
            />
        </ValidatorForm>
    );
}
const withConnectState = connect(
    (state, ownProps) => ({}),
    dispatch => bindActionCreators(
      {
        onCloseModal: closeModal,
        onCreateUnregisterStudy: createUnregisterStudy,
        onGetSummary: getProtocolDetails
      },
      dispatch
    )
  );

const UnregisterStudy = compose(
  withConnectState,
  withState('state', 'setState', { ...defaultUnregisteredStudy }),
  withHandlers({    
    handleSelChange: props => (item, selItem, key) => {
        const { state, setState } = props;
        selItem(item);
        const obj = { ...state };
        obj[key] =  item ? item.value : '';
        setState({ ...obj });
    },
    resetForm: props => () => {
        const { setState } = props;
        setState({ ...defaultUnregisteredStudy });
    },
    cancel: props => cancelModal(props.onCloseModal)
  }),
  withHandlers({
    saveUnregisterStudy: props => (ctx, onSaveUnregisterStudy, history) => {
        const { state, resetForm, onCloseModal,onGetSummary } = props;
        bindLogger(onSaveUnregisterStudy, ctx)(state).subscribe(resp => {
            if (resp.status === httpStatusEnum.SUCCESS) {
                openSnackbar({
                    message: "Unregistered Study is successfully created.",
                    variant: 'success',
                    name: 'unregisteredStudy'
                });
                resetForm();
                onCloseModal();
                bindLogger(onGetSummary, ctx)(state?.protocolNumber)
                const encodedUrl = getEncodedQueryParams('/protocol/',`${state?.protocolNumber}/protocoldetail`)
                history.push(encodedUrl, { shallow: true });
            }
        }, err => {
            ctx.logError(ctx, err.message, err.response.error);
            openConfirmation({
                title: 'Validation:',
                message: `${err.response.error}`,
                onAction: () => { },
                name: 'Un_Registered_Study_Validation'
              });
          });
    }
  }),
  withChangeHandlers
)(CreateUnregisterStudy);
  
export default UnregisterStudy;